module.exports = __webpack_public_path__ + "static/media/student-badge-back2.1cda4f98.jpg";